import React, { useContext, useEffect, useState } from 'react';
import { WalletContext } from '../../appContext';
import useDeviceType from '../../utils/useDeviceType';
import AmountPayDueMOB from '../../PageComponentData/wallet/AmountPayDueMobile';
import AmountPayDueWeb from '../../PageComponentData/wallet/AmountPayDueDesktop';
import WalletPageReturn from './WalletPage';

function VerifyBankIndex({ balance }) {

  const deviceType = useDeviceType();
   const [handelWithdrawBlock, doctorProfile] = useContext(WalletContext);
  return (
    <>
      {(deviceType == 'Mobile' || deviceType == 'Tablet') ? (
        <AmountPayDueMOB isOpen={true} closefun={handelWithdrawBlock}>
          <WalletPageReturn balance={balance} />
        </AmountPayDueMOB>
      ) : (
        <AmountPayDueWeb isOpen={true} closefun={handelWithdrawBlock} isRegular={true}>
          <WalletPageReturn balance={balance} />
        </AmountPayDueWeb>
      )}
    </>


  );
}

export default VerifyBankIndex;
